import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=620e9566&scoped=true&"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js&"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDashboard.vue?vue&type=style&index=0&id=620e9566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e9566",
  null
  
)

export default component.exports